import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";

const initialForm = {
    nombreCompleto: '',
    usuario: '',
    password: '',
}

export const CrearUsuarioModal = ({ show, onClose, onSave }) => {


    const [form, setForm] = useState(initialForm);

    useEffect(() => {
        if (!show) resetForm();
    }, [show]);

    const resetForm = () => {
        setForm(initialForm);
    };


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = () => {
        console.log(form);

        if (!form.nombreCompleto.trim()) return;
        if (!form.usuario.trim()) return;
        if (!form.password.trim()) return;

        onSave({
            ...form,
            nombreCompleto: form.nombreCompleto.toUpperCase(),
            usuario: form.usuario.toUpperCase(),
            password: form.password.toUpperCase(),
        });
    };



    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="lg"
            contentClassName="rounded-4 shadow-lg border-0"
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold fs-4">
                    Crear Usuario
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form className="row g-3">

                    <Form.Group className="col-12">
                        <Form.Label>Usuario</Form.Label>
                        <Form.Control
                            name="usuario"
                            value={form.usuario}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-12">
                        <Form.Label>Nombre Completo</Form.Label>
                        <Form.Control
                            name="nombreCompleto"
                            value={form.nombreCompleto}
                            onChange={handleChange}
                        />
                    </Form.Group>


                    <Form.Group className="col-12">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            name="password"
                            value={form.password}
                            onChange={handleChange}
                        />
                    </Form.Group>

                </Form>
            </Modal.Body>

            <Modal.Footer className="border-0">
                <Button variant="light" onClick={onClose}>
                    Cancelar
                </Button>

                <Button variant="primary" onClick={handleSubmit}>
                    Guardar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};